module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('section', {
    staticClass: "gallery inner-screen"
  }, [_c('div', {
    staticClass: "gallery__cont"
  }, _vm._l((_vm.images), function(image, index) {
    return _c('div', {
      staticClass: "gallery__item"
    }, [_c('img', {
      attrs: {
        "src": image,
        "alt": ""
      }
    }), _vm._v(" "), _c('p', {
      staticStyle: {
        "line-height": "1.2"
      },
      domProps: {
        "innerHTML": _vm._s(_vm.imageTitle[index].title)
      }
    })])
  }))])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-2ce4d200"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/Gallery.vue
// module id = 561
// module chunks = 1